import MainLayoutPages from "../Layout/MainLayout";
import Home from "../Pages/Home";
import Profile from "../Pages/Profile";
import Cities from "../Pages/Cities/index";
import CheckMobile from "../Pages/Auth/CheckMobile";
import VerifyCode from "../Pages/Auth/VerifyCode";
import PrivacyPolicy from "../Pages/Auth/PrivacyPolicy";
import SignUp from "../Pages/Auth/SignUp";
import AuthLayout from "../Layout/Auth";
import Completion from "../Pages/Profile/Pages/Completion";
import Single from "../Pages/Single";
import List from "../Pages/List";
import PageLayout from "../Layout/PageLayout";
import SubmitAds from "../Pages/SubmitAds";
import Plan from "../Pages/Profile/Pages/Plan";

import Support from "../Pages/Profile/Pages/Support";

import Categories from "../Pages/Categories";
import CreateAds from "../Pages/Advertisment/Create";
import PaymentList from "../Pages/Payments/List";
import Chat from "../Pages/Profile/Pages/Chat";
import BookMark from "../Pages/BookMark";
import ListAds from "../Pages/Advertisment/List";
import SingleMyAds from "../Pages/Advertisment/Single";
import Preview from "../Pages/Advertisment/Preview";
import Edit from "../Pages/Advertisment/Edit";
export const routes = [
  // {
  //   path: "*",
  //   component: NotFound,
  //   layout: Layout,
  // },
  {
    path: "/",
    component: Home,
    layout: MainLayoutPages,
  },
  {
    path: "/profile",
    component: Profile,
    layout: MainLayoutPages,
  },
  {
    path: "/cities",
    component: Cities,
    layout: MainLayoutPages,
  },
  {
    path: "/check",
    component: CheckMobile,
    layout: AuthLayout,
  },
  {
    path: "/verify-code",
    component: VerifyCode,
    layout: AuthLayout,
  },
  {
    path: "/PrivacyPolicy",
    component: PrivacyPolicy,
    layout: AuthLayout,
  },
  {
    path: "/sign-up",
    component: SignUp,
    layout: AuthLayout,
  },
  {
    path: "/completion",
    component: Completion,
    layout: PageLayout,
  },

  {
    path: "/list",
    component: List,
    layout: PageLayout,
  },
  {
    path: "/list/:slug",
    component: Single,
    layout: PageLayout,
  },
  {
    path: "/submit-ads",
    component: CreateAds,
    layout: MainLayoutPages,
  },
  {
    path: "/plan",
    component: Plan,
    layout: PageLayout,
  },
  {
    path: "/payments",
    component: PaymentList,
    layout: PageLayout,
  },
  {
    path: "/support",
    component: Support,
    layout: PageLayout,
  },
  {
    path: "/support/:ticket_id",
    component: Chat,
    layout: PageLayout,
  },
  {
    path: "/categories",
    component: Categories,
    layout: MainLayoutPages,
  },
  {
    path: "/bookmarks",
    component: BookMark,
    layout: PageLayout,
  },
  {
    path: "/my-ads",
    component: ListAds,
    layout: PageLayout,
  },
  {
    path: "/my-ads/:id",
    component: SingleMyAds,
    layout: PageLayout,
  },
  {
    path: "/my-ads-preview/:id",
    component: Preview,
    layout: PageLayout,
  },
  {
    path: "/my-ads-edit/:id",
    component: Edit,
    layout: PageLayout,
  },
];
